import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, of } from 'rxjs';
import { jwtDecode } from "jwt-decode";
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import {environment} from "../../../environment/environment";


@Injectable({
  providedIn: 'root'
})
export class ItineraryauthService {
  private tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  private apiUrl = environment.itinerary_base_url;
  private clientId = environment.itinerary_client_id;
  private clientSecret = environment.itinerary_client_secret_key;
  private readonly TOKEN_KEY = 'itinerary_auth_token';
  private readonly REFRESH_TOKEN_KEY = 'itinierary_auth_refresh_token';
  constructor(private http: HttpClient) {}

  setRefreshToken(token: any): void {
    localStorage.setItem(this.REFRESH_TOKEN_KEY, token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  removeRefreshToken(): void {
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
  }

  setToken(token: any): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  removeToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  generateToken(): Observable<string | any> {
    const tokenUrl = `${environment.itinerary_base_url}token/`;
    console.log(tokenUrl)
    const body = { client_id: this.clientId, client_secret: this.clientSecret };
    return this.http.post<any>(tokenUrl, body).pipe(
      map(response => {
        console.log(response);
        this.setToken(response.access_token);
        this.setRefreshToken(response.refresh_token);
        return response.access_token; // Return the actual token, not an observable
      }),
      catchError(error => {
        console.error('Error generating token:', error);
        return throwError('Failed to generate token');
      })
    )
  }

  getToken(): Observable<string | null  > {
    const token = localStorage.getItem(this.TOKEN_KEY);
    if (token) {
      
      return this.checkTokenExpiration(token).pipe(
        switchMap((isValid) => {

          if (!isValid) {
            return this.generateToken();
          } else {
            return of(token);
          }
        })
      );
    } else {
      return this.generateToken();
    }
    
    return of("test")
  }

  private refreshToken(): Observable<string> {
    // Implement token refresh logic here
    // This method should refresh the token by making a request to the token endpoint
    // and updating the tokenSubject with the new token
    // Example:
    // const refreshTokenUrl = 'your_refresh_token_endpoint';
    // return this.http.post<any>(refreshTokenUrl, { refreshToken }).pipe(
    //   map(response => response.access_token),
    //   tap(token => this.tokenSubject.next(token)),
    //   catchError(error => {
    //     console.error('Error refreshing token:', error);
    //     return throwError('Failed to refresh token');
    //   })
    // );
    return this.generateToken(); // Placeholder for demonstration (use actual refresh logic)
  }

  private checkTokenExpiration(token:string): Observable<boolean | any> {
    const decodedToken: any = jwtDecode(token?? "");
    console.log(decodedToken)
    if (!decodedToken.exp) {
      return of(false); //No expiry date found in token
    }
    const expiryTimestamp = decodedToken.exp * 1000; // Convert to milliseconds
    const currentTimestamp = new Date().getTime();
    console.log(expiryTimestamp)
    console.log(currentTimestamp)
    return of(expiryTimestamp > currentTimestamp);
    //return of(true);
  }

  getData(): Observable<any> {
    return this.getToken().pipe(
      switchMap(token => {
        if (token) {
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          return this.http.get<any>(this.apiUrl, { headers }).pipe(
            catchError(error => {
              console.error('Error fetching data:', error);
              return throwError('Failed to fetch data');
            })
          );
        } else {
          return throwError('No valid token available');
        }
      })
    );
  }
}
